import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "../context/LangContext";
import { useTheme } from "../context/ThemeContext";
import { programData, translations } from "./translation";

import o1 from "../sessia0/1.jpg";
import o2 from "../sessia0/2.png";
import o3 from "../sessia0/3.jpg";
import o4 from "../sessia0/4.jpeg";
import o5 from "../sessia0/5.jpg";
import o6 from "../sessia0/6.jpg";
import o7 from "../sessia0/7.jpg";
import o8 from '../sessia0/8.jpg'

import s1_1 from "../sessia1/1.jpeg";
import s1_2 from "../sessia1/2.jpg";
import s1_3 from "../sessia1/3.jpg";
import s1_4 from "../sessia1/4.jpeg";
import s1_5 from "../sessia1/5.jpg";
import s1_6 from "../sessia1/galkin.jpg";
import s1_7 from "../sessia1/7.jpeg";

import s2_1 from "../sessia2/1.jpg";
import s2_2 from "../sessia2/2.jpg";
import s2_3 from "../sessia2/3.jpg";
import s2_4 from "../sessia2/4.jpg";
import s2_5 from "../sessia2/5.jpg";
import s2_7 from "../sessia2/kuharka.jpg";
import s2_9 from "../sessia2/9.jpg";

import s3_1 from "../sessia3/1.jpg";
import s3_2 from "../sessia3/2.jpg";
import s3_6 from "../sessia3/6.jpg";
import s3_4 from "../sessia3/4.jpg";
import s3_5 from "../sessia3/5.jpg";
import s3_7 from "../sessia3/li.jpg";

import s4_1 from "../sessia4/1.png";
import s4_2 from "../sessia4/2.jpg";
import s4_3 from "../sessia4/3.jpg";
import s4_4 from "../sessia4/4.jpg";
import s4_5 from "../sessia4/5.jpg";
import s4_6 from '../sessia4/Сейдахматова.jpeg'

const sessionImages = {
  // o5,
  0: [o4, o1, o6, o8,o5, o2, o7],
  1: [s1_4, s1_5, s1_6, s1_1, s1_2,s1_7],
  2: [s2_9, s2_3,s2_4,s2_5, s2_1,   s2_7],
  // s2_2,
  3: [s3_2, s3_5, s3_1, s3_4, s3_6, s3_7],
  4: [s2_5, s4_1, s4_4, s4_5,s4_6],
  // s4_2,
};

export default function Program() {
  const [active, setActive] = useState(null);
  const { lang } = useLang();
  const { theme } = useTheme();

  const program = programData[lang];
  const t = translations;

  return (
    <section
      style={{
        // padding: "120px 20px",
        background: theme.bg,
        color: theme.text,
      }}
    >
      <h2
        style={{
          textAlign: "center",
          fontSize: "clamp(32px, 5vw, 56px)",
          marginBottom: "60px",
          color: theme.secondaryText,
        }}
      >
        {t.programTitle[lang]}
      </h2>

      <div style={{ maxWidth: "900px", margin: "0 auto" }}>
        {program.map((item, i) => {
          const isOpen = active === i;

          return (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.2 }}
              style={{
                marginBottom: "20px",
                borderRadius: "16px",
                overflow: "hidden",
                border: `1px solid ${theme.border}`,
                background: theme.card,
                backdropFilter: "blur(10px)",
              }}
            >
              {/* HEADER */}
              <div
                onClick={() => setActive(isOpen ? null : i)}
                style={{
                  padding: "20px",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {/* rgba(171, 229, 233) */}
                <div>
                  <div style={{ color: "#fff", fontWeight: 600 }}>
                    {item.time}
                  </div>
                  <h3 style={{ color: "#fff" }}>{item.title}</h3>
                  {/* 📌 SUBTITLE */}
                  {item.subtitle && (
                    <div
                      style={{
                        marginBottom: "20px",
                        color: "#fff",
                        fontStyle: "italic",
                        fontSize: "15px",
                      }}
                    >
                      «{item.subtitle}»
                    </div>
                  )}
                </div>

                <div style={{ fontSize: "20px", color: "#fff" }}>
                  {isOpen ? "−" : "+"}
                </div>
              </div>

              {/* CONTENT */}
              <AnimatePresence>
                {isOpen && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    style={{
                      padding: "24px",
                      borderTop: `1px solid ${theme.border}`,
                    }}
                  >
                    {/* 👤 МОДЕРАТОР */}
                    {item.moderator && (
                      <div
                        style={{
                          marginBottom: "25px",
                          padding: "18px",
                          background:
                            "linear-gradient(135deg, rgba(25,118,210,0.12), rgba(25,118,210,0.05))",
                          borderRadius: "12px",
                          border: "1px solid rgba(25,118,210,0.3)",
                        }}
                      >
                        <div style={{ color: theme.text, fontWeight: 600 }}>
                          {t.moderator[lang]}
                        </div>

                        <div style={{ color: theme.text, marginTop: "5px" }}>
                          {item.moderator}
                        </div>

                        {item.moderatorTopic && (
                          <div
                            style={{
                              marginTop: "10px",
                              fontSize: "14px",
                              color: theme.text,
                            }}
                          >
                            {item.moderatorTopic}
                          </div>
                        )}
                      </div>
                    )}

                    {/* 🧑‍💼 ФОТО */}
                    {sessionImages[i] && (
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "10px",
                          marginBottom: "20px",
                        }}
                      >
                        {sessionImages[i].map((img, idx) => (
                          <motion.img
                            key={idx}
                            src={img}
                            alt=""
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ delay: idx * 0.05 }}
                            whileHover={{ scale: 1.1 }}
                            style={{
                              width: "52px",
                              height: "52px",
                              borderRadius: "50%",
                              objectFit: "cover",
                              border: "2px solid white",
                            }}
                          />
                        ))}
                      </div>
                    )}

                    {/* 🧠 СПИКЕРЫ С СКАЧИВАНИЕМ */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                      }}
                    >
                      {item.speakers.map((s, idx) => (
                        <motion.div
                          key={idx}
                          onClick={() => {
                            if (s.file) {
                              const link = document.createElement("a");
                              link.href = s.file;

                              // 🔥 автоматически определяем расширение файла
                              const ext = s.file.split(".").pop();

                              link.download = `${s.name}.${ext}`;
                              link.click();
                            }
                          }}
                          initial={{ opacity: 0, x: -20 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ delay: idx * 0.05 }}
                          whileHover={{
                            scale: 1.02,
                            boxShadow: "0 10px 25px rgba(25,118,210,0.2)",
                          }}
                          style={{
                            padding: "16px",
                            borderRadius: "12px",
                            background: theme.card,
                            border: `1px solid ${theme.border}`,
                            cursor: s.file ? "pointer" : "default",
                          }}
                        >
                          <div style={{ color: theme.text, fontWeight: 500 }}>
                            {idx + 1}. {s.name}
                          </div>

                          <div
                            style={{
                              color: theme.text,
                              fontSize: "14px",
                              marginTop: "4px",
                            }}
                          >
                            {s.desc}
                          </div>

                          {s.topic && (
                            <div
                              style={{
                                marginTop: "6px",
                                color: theme.text,
                                fontSize: "13px",
                              }}
                            >
                              «{s.topic}»
                            </div>
                          )}

                          {s.file && (
                            <div
                              style={{
                                marginTop: "8px",
                                color: "#fff",
                                fontSize: "13px",
                              }}
                            >
                              {t.download[lang]}
                            </div>
                          )}
                        </motion.div>
                      ))}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
